<template>
  <div class="main">
    <GoBack :name="`答题签到`" :type="2" :path="`/mobile/home`"></GoBack>
    <div v-if="!show">
      <!-- //阴影 -->
      <img class="shadow" src="@/assets/mobile/image/common/shadow.png" />

      <div class="content">
        <img class="wenti" src="@/assets/mobile/image/home/wenti.png" />
        <div class="title">{{ answerRegisterStatus.question.title }}</div>

        <div class="list-box" v-if="answerRegisterStatus.question.typeID === 1">
          <div
            :class="[
              'list-item',
              { 'list-active': answerOptions.optionIds.includes(item.id) },
            ]"
            v-for="item in answerRegisterStatus.question.options"
            :key="item.title"
            @click="cheageActive1(item)"
          >
            {{ item.title }}
          </div>
        </div>

        <div class="list-box" v-if="answerRegisterStatus.question.typeID === 2">
          <div
            :class="[
              'list-item',
              { 'list-active': answerOptions.optionIds.includes(item.id) },
            ]"
            v-for="item in answerRegisterStatus.question.options"
            :key="item.title"
            @click="cheageActive2(item)"
          >
            {{ item.title }}
          </div>
        </div>

        <button class="btn" @click="answerSigninQuestion">提交</button>
      </div>
    </div>
    <div class="mian-content" v-if="show">
      <div class="bg">
        <div class="gold-box">
          <img class="gold-coin2" src="@/assets/image/gold-coin2.png" />
          <img class="gold-coin2-bg" src="@/assets/image/gold-coin2-bg.png" />
        </div>
      </div>

      <div class="content">
        <div class="sign-in">
          <div class="sign-top">
            <img class="img-left" src="@/assets/image/sign-arrow.png" />
            <span>{{ isComplete ? "今日签到成功" : "未签到" }}</span>
            <img class="img-right" src="@/assets/image/sign-arrow.png" />
          </div>
          <div class="register-calendar-main">
            <div class="big-month-bg">{{ month }}</div>
            <div
              class="register-calendar-week"
              v-for="item in weekList"
              :key="item"
            >
              <div>{{ item }}</div>
            </div>
            <div
              class="register-calendar-day"
              v-for="(item, index) in answerRegisterStatus.dateList"
              :key="index"
            >
              <div
                :class="
                  item.bgColor
                    ? 'register-calendar-day-item lastday'
                    : 'register-calendar-day-item'
                "
              >
                <span v-if="!item.isRmb">{{ item.day }}</span>
                <img
                  v-else
                  class="rmb"
                  src="@/assets/image/gold-coin.png"
                  alt="图片"
                />
              </div>
            </div>
          </div>
        </div>
        <div
          @click="setSignin"
          :class="['btn2', { 'btn-opacity': isComplete }]"
        >
          {{ isComplete ? "已签到" : "今日签到" }}
        </div>
        <div class="tips">
          注：每天只能签到一次，签到成功后，系统将会自动奖励您1金币，签到过程中，如果遇到任何问题，请联系我们的官方公众号客服。
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import GoBack from "@/components/goBack";
import {
  getSignedDays,
  getSigned,
  setSignin,
  getAccount,
  getWeChatAuthWechatUrl,
  getSigninQuestions,
  answerSigninQuestion,
} from "@/api/mobile";
import { generateUUID } from "@/utils/replace";
import { getDateList } from "@/utils/calendar";
export default {
  data() {
    return {
      weekList: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
      list: [
        {
          name: "A.苹果",
        },
        {
          name: "B.香蕉",
        },
        {
          name: "C.橘子",
        },
      ],
      active: null,
      show: false,
      number: 1,

      answerRegisterStatus: {
        answerDialogVisible: false,
        dateList: [],
        answerIndex: "",
        registerDialogVisible: false,
        question: {},
      },
      isComplete: false,
      takeInLoading: false,
      userid: null,
      isAnswer: false,
      flag: false,
      month: 1,
      weixinFlag: false,

      answerOptions: {
        questionId: 0,
        optionIds: [],
      },
    };
  },
  components: {
    GoBack,
  },
  methods: {
    cheageActive1(item) {
      // 参数校验
      if (!item || !item.id) {
        console.warn("Invalid item or missing id");
        return;
      }

      // 单选逻辑：清空数组，只保留当前选中的 id
      this.answerOptions.optionIds = [item.id];
    },

    cheageActive2(item) {
      // 参数校验
      if (!item || !item.id) {
        console.warn("Invalid item or missing id");
        return;
      }

      const index = this.answerOptions.optionIds.indexOf(item.id);

      if (index === -1) {
        // id 不存在，添加到数组中
        this.answerOptions.optionIds.push(item.id);
      } else {
        // id 存在，从数组中删除
        this.answerOptions.optionIds.splice(index, 1);
      }
    },
    //问题
    async getSigninQuestions() {
      await getSigninQuestions().then((res) => {
        if (res.code === 200) {
          this.answerRegisterStatus.question = res.data;
        }
      });
    },
    //今日是否签到
    async getSigned() {
      await getSigned().then((res) => {
        if (res.code === 200) {
          this.answerRegisterStatus.signed = res.data.signed;
          this.answerRegisterStatus.totalDays = res.data.totalDays;
          this.isComplete = res.data.signed;
          this.show = this.isComplete;
        }
      });
    },
    async getSignedDays() {
      await getSignedDays().then((res) => {
        if (res.code === 200) {
          if (res.data && res.data.length !== 0) {
            const newDays = res.data.map((item) => item.day);
            this.answerRegisterStatus.dateList = getDateList(newDays);
          } else {
            this.answerRegisterStatus.dateList = getDateList([]);
          }
        }
      });
    },

    async setSignin() {
      if (this.flag) {
        return;
      }
      this.flag = true;
      if (this.isComplete) {
        return;
      }
      await setSignin().then(async (res) => {
        this.flag = false;
        if (res.code === 200) {
          this.$toast("签到成功");
          await this.getSignedDays();
          this.isComplete = true;
        }
      });
    },

    answerSigninQuestion() {
      this.answerOptions.questionId = this.answerRegisterStatus.question.id;
      answerSigninQuestion(this.answerOptions).then((res) => {
        if (res.code === 200) {
          this.show = true;
        }
      });
    },
  },

  async created() {
    //微信自动登录
    if (this.$route.query.from && this.$route.query.from === "wechat") {
      this.weixinFlag = true;
      let state = generateUUID();
      let redirectUrl =
        "https://www.aidajuan.com/mobile/landingPage?url=" + "/mobile/signIn";
      await getWeChatAuthWechatUrl({
        redirectUrl,
        state,
      }).then((res) => {
        if (res.code === 200) {
          window.location.href = res.data;
        }
      });
    }

    if (this.weixinFlag) {
      return;
    }

    await this.getSignedDays();
    await this.getSigned();
    await this.getSigninQuestions();

    const date = new Date();
    this.month = date.getMonth() + 1; // 获取当前月份（1-12）
  },
};
</script>
<style lang="scss" scoped>
.main {
  position: relative;
  width: 100%;
  min-height: 100vh;
  background-color: #ffffff;
  .shadow {
    position: absolute;
    width: 100%;
    top: 0;
    z-index: 0;
  }
  .content {
    padding: 0 16px;
    position: relative;
    z-index: 1;
    .wenti {
      width: 100%;
    }
    .title {
      color: #333333;
      font-size: 14px;
      margin: 28px 0 20px 0;
    }
    .list-box {
      .list-item {
        width: 100%;
        height: 40px;

        border-radius: 4px 4px 4px 4px;
        margin-bottom: 10px;
        font-size: 14px;
        color: #333333;
        line-height: 40px;
        text-indent: 14px;
        background-color: #fafafa;
      }
      .list-active {
        background: rgba(241, 155, 56, 0.1);
        color: #ff9600;
      }
    }
    .btn {
      margin: 0;
      padding: 0;
      border: none;
      margin-top: 25px;
      margin-bottom: 25px;
      width: calc(100% - 100px);
      height: 36px;
      background: linear-gradient(153deg, #be9aff 0%, #8846ff 100%);
      border-radius: 18px 18px 18px 18px;
      font-size: 14px;
      color: #fff;
      transform: translateX(-50%);
      position: relative;
      left: 50%;
    }
  }
  .zhezaho {
    position: fixed;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 0px 0px 0px 0px;
    z-index: 100;
    top: 0;
    left: 0;
  }
  .tank {
    position: absolute;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    z-index: 101;
    width: 330px;
    top: 50%;
    .qd {
      width: 100%;
    }
    .tank-content {
      width: 330px;
      height: 309px;
      background: #ffffff;
      border-radius: 14px 14px 14px 14px;
      position: relative;
      top: -30px;
      .tank-1 {
        display: flex;
        justify-content: space-between;
        padding: 0 15px;
        padding-top: 29px;
        .tank-item {
          width: 66px;
          height: 75px;
          background: #f7f8ff;
          border-radius: 6px 6px 6px 6px;
          border: 1px solid #637dff;
          .q-fa {
            position: relative;
            text-align: center;
            color: 8px;
            font-size: 8px;
            color: #fff;
            .q-top {
              position: absolute;
              height: 15px;
              width: 44px;
              left: 50%;
              transform: translateX(-50%);
              top: -1px;
              z-index: 1;
            }
            span {
              position: relative;
              z-index: 2;
            }
          }
        }
        .tank-active {
          // border-color: #fff;
          opacity: 0.4;
          // background: #f7f8ff;
        }
      }
      .tank-2 {
        display: flex;
        justify-content: center;
        padding-top: 12px;
        .tank-item {
          width: 66px;
          height: 75px;
          background: #f7f8ff;
          border-radius: 6px 6px 6px 6px;
          border: 1px solid #637dff;
          margin-right: 12px;
          .q-fa {
            position: relative;
            text-align: center;
            color: 8px;
            font-size: 8px;
            color: #fff;
            .q-top {
              position: absolute;
              height: 15px;
              width: 44px;
              left: 50%;
              transform: translateX(-50%);
              top: -1px;
              z-index: 1;
            }
            span {
              position: relative;
              z-index: 2;
            }
          }
        }
        .tank-item:last-child {
          margin-right: 0;
        }
        .tank-active {
          // border-color: #fff;
          opacity: 0.4;
          // background: #f7f8ff;
        }
      }
      .gb {
        width: 28px;
        height: 28px;
        position: relative;
        left: 50%;
        transform: translateX(-50%);
        margin-top: 9px;
      }
      .day {
        font-size: 10px;
        color: #232323;
        font-weight: bolder;
        text-align: center;
        margin-top: 7px;
      }
      .tips {
        color: #474f66;
        font-size: 11px;
        text-align: center;
        margin-top: 22px;
      }
      .tank-btn {
        width: 126px;
        height: 33px;
        line-height: 33px;
        background: linear-gradient(141deg, #a896ff 0%, #8b4eff 100%);
        border-radius: 23px 23px 23px 23px;
        color: #ffffff;
        font-size: 13px;
        font-weight: bolder;
        text-align: center;
        position: relative;
        left: 50%;
        transform: translateX(-50%);
        margin-top: 24px;
      }
    }
    .close {
      width: 16px;
      height: 16px;
      position: relative;
      left: 50%;
      transform: translateX(-50%);
    }
  }
}

.mian-content {
  width: 100%;

  .bg {
    width: 100%;
    height: 226px;
    background-image: url("../../assets/image/bg1.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;

    .gold-box {
      position: relative;
      width: 200px;
      left: 50%;
      transform: translateX(-50%);
      top: 45px;

      .gold-coin2 {
        position: absolute;
        width: 113px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 1;
        top: 12px;
      }

      .gold-coin2-bg {
        position: absolute;
        width: 165px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 0;
      }
    }
  }

  .content {
    padding: 0 15px;
    position: relative;
    z-index: 2;
    top: -70px;

    .sign-in {
      width: 100%;
      border-radius: 30px 30px 0 0;
      background-color: #fff;
      padding-bottom: 20px;

      .sign-top {
        padding-top: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #ff643c;
        font-size: 14px;
        font-weight: bold;

        img {
          width: 36px;
          height: 1px;
        }

        .img-right {
          margin-left: 30px;
        }

        .img-left {
          margin-right: 30px;
          transform: rotate(180deg);
        }
      }

      .register-calendar-main {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        position: relative;

        .big-month-bg {
          position: absolute; /* 绝对定位 */
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%); /* 完美居中 */
          font-size: 260px; /* 极大的字号 */
          font-weight: 900;
          color: #3498db; /* 经典复古蓝 */
          opacity: 0.12; /* 极低透明度，形成水印背景感 */
          z-index: 0; /* 放在最底层 */
          pointer-events: none; /* 防止挡住下方日期的点击 */
        }
      }

      .register-calendar-week {
        width: 14.285%;
        height: 50px;
        line-height: 50px;
        text-align: center;
        font-size: 12px;
        margin-top: 10px;
        color: #0a0a0a;
      }

      .register-calendar-day {
        width: 14.285%;
        height: 40px;
        line-height: 40px;
        text-align: center;
        font-size: 12px;
        color: #0a0a0a;
      }

      .register-calendar-day-item {
        width: 40px;
        height: 40px;
        background-color: #fff;
        border-radius: 5px;
        /* cursor: pointer; */
        margin: 0 auto;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .lastday {
        color: #dac5c5;
        cursor: auto;
      }

      .rmb {
        width: 22px;
        height: 22px;
      }
    }

    .btn2 {
      width: calc(100% - 80px);
      height: 46px;
      background: linear-gradient(153deg, #be9aff 0%, #8846ff 100%);
      border-radius: 25px 25px 25px 25px;
      text-align: center;
      line-height: 46px;
      color: #ffffff;
      font-size: 18px;
      box-sizing: border-box;
      margin-left: 40px;
      margin-top: 30px;
    }

    .tips {
      color: #ff6017;
      font-size: 14px;
      margin-top: 38px;
    }

    .btn-opacity {
      opacity: 0.6;
    }
  }
}
</style>